/** @format */

import React from 'react'
import { Select, Input, SelectProps, InputProps } from '@king-design/react'
import styled from 'styled-components'

interface SelectInputProps extends InputProps {
  className?: string
  selectProps?: SelectProps
  options: any
  width?: number
  onChange?: (inputValue: any, selectValue: any) => void
}

const SelectInput: React.FC<SelectInputProps> = ({
  className,
  onChange,
  options,
  width = 350,
  ...props
}) => {
  const { selectProps } = props
  return (
    <Input
      className={className}
      width={width}
      {...props}
      onChangeValue={value => {
        onChange(value, selectProps.value)
      }}
      slotPrepend={
        <Select
          width={120}
          onChangeValue={value => {
            onChange(props.value, value)
          }}
          {...selectProps}
        >
          {options}
        </Select>
      }
    ></Input>
  )
}

export default styled(SelectInput)`
  .k-select {
    height: 32px;
  }
`
